module.exports = function() {
  return new Worker(__webpack_public_path__ + "15903f892766d3a4d937.worker.js");
};